import { ArrayNotEmpty, ArrayUnique, ValidateNested } from 'class-validator';
import { Type } from 'class-transformer';
import { IsValidNumber, IsValidString } from '@cnx-saas/common';
import {
  Article,
  OrderArticle,
  OrderInput,
  Location,
  OrderType,
  MatchOrder,
  LoadArticle,
} from '../types';
import { ArticleInputValidationSchema } from './Article';
import { LocationInputValidationSchema } from './Location';
import { LoadArticleInputValidationSchema } from './Load';

class OrderArticleInputValidationSchema implements OrderArticle {
  @ValidateNested()
  @Type(() => ArticleInputValidationSchema)
  article: Article;

  @IsValidNumber({ integer: true, min: 1, max: 9999 })
  totalQuantity: number;

  @IsValidNumber({ integer: true })
  totalLoadingMillimeter: number;

  @IsValidNumber({ integer: false })
  totalWeightInKg: number;
}

export class OrderInputValidationSchema implements OrderInput {
  @IsValidString({ optional: true })
  externalReference?: string;

  deadline?: Date;
  type: OrderType;

  @ValidateNested()
  @Type(() => LocationInputValidationSchema)
  location: Location;

  @ArrayNotEmpty({
    context: {
      messageKey: 'orders.error.articles.arrayNotEmpty',
      data: { defaultValue: 'Articles must no be empty' },
    },
  })
  @ValidateNested({ each: true })
  // @ArrayUnique<OrderArticle>((i) => i.article.id, {
  //   context: {
  //     messageKey: 'orders.error.arrayUnique',
  //     data: { defaultValue: 'Articles must be unique' },
  //   },
  // })
  @Type(() => OrderArticleInputValidationSchema)
  articles: OrderArticle[];
}

export class MatchOrderInputValidationSchema implements MatchOrder {
  @ValidateNested({ each: true })
  // @ArrayUnique<LoadArticle>((i) => i.article.id)
  @Type(() => LoadArticleInputValidationSchema)
  articles: LoadArticle[];

  matchedLocation: Location;
}
